{
  "*Taxes will be calculated when the invoice is created.": "*Taxes will be calculated when the invoice is created.",
  "Canceled": "Canceled",
  "Clear": "Clear",
  "Collapse widget": "Collapse widget",
  "Contact Support": "Contact Support",
  "Copy Tracking Number": "Copy Tracking Number",
  "Device Order": "Device Order",
  "Device Orders": "Device Orders",
  "Expand widget": "Expand widget",
  "Filter": "Filter",
  "Locations": "Locations",
  "No Image Available": "No Image Available",
  "Order Date": "Order Date",
  "Order Details": "Order Details",
  "Order Number": "Order Number",
  "Order Placed": "Order Placed",
  "Order Placed on {{date}}": "Order Placed on {{date}}",
  "Order Total": "Order Total",
  "Order placed on {{orderDate}}": "Order placed on {{orderDate}}",
  "Partially Shipped": "Partially Shipped",
  "Phone Model Name": "Phone Model Name",
  "Processing": "Processing",
  "Qty:": "Qty:",
  "Refresh": "Refresh",
  "Search": "Search",
  "Select All": "Select All",
  "Shipped": "Shipped",
  "Shipped on {{date}}_one": "Shipped on {{date}}",
  "Shipped on {{date}}_other": "Packages Shipped on {{date}}",
  "Shipped on {{shippedDate}}": "Shipped on {{shippedDate}}",
  "Status": "Status",
  "Taxes": "Taxes",
  "There are currently no locations accessible for viewing {{pageTitle}}.": "There are currently no locations accessible for viewing {{pageTitle}}.",
  "Total": "Total",
  "Track Package on {{carrier}}": "Track Package on {{carrier}}",
  "Tracking #'s:": "Tracking #'s:",
  "Tracking #:": "Tracking #:",
  "Tracking Numbers:": "Tracking Numbers:",
  "Unknown": "Unknown",
  "View Details": "View Details",
  "View and manage device orders made through Weave.": "View and manage device orders made through Weave.",
  "View and manage device orders made through Weave. Select your preferred location to continue:": "View and manage device orders made through Weave. Select your preferred location to continue:",
  "Your order has been canceled._one": "Your order has been canceled.",
  "Your order has been canceled._other": "Your orders have been canceled.",
  "Your order has been placed! We'll let you know when it ships._one": "Your order has been placed! We'll let you know when it ships.",
  "Your order has been placed! We'll let you know when it ships._other": "Your orders have been placed! We'll let you know when it ships.",
  "Your order has partially shipped! Track your package for the latest delivery updates._one": "Your order has partially shipped! Track your package for the latest delivery updates.",
  "Your order has partially shipped! Track your package for the latest delivery updates._other": "Your orders have partially shipped! Track your package for the latest delivery updates.",
  "Your order has shipped! Track your package for the latest delivery updates._one": "Your order has shipped! Track your package for the latest delivery updates.",
  "Your order has shipped! Track your package for the latest delivery updates._other": "Your orders have shipped! Track your package for the latest delivery updates.",
  "Your order is processing! We'll let you know when it ships._one": "Your order is processing! We'll let you know when it ships.",
  "Your order is processing! We'll let you know when it ships._other": "Your orders are processing! We'll let you know when it ships.",
  "{{carrier}} Tracking:": "{{carrier}} Tracking:",
  "{{count}} Active Orders_one": "{{count}} Active Order",
  "{{count}} Active Orders_other": "{{count}} Active Orders"
}
